import React from "react";
import { withRouter } from "react-router-dom";
import Footer from "../Mobile/Footer";
import DeliveryBottomNav from "../Delivery/Shared/BottomNav";
import { isDesktopViewport } from "../../helpers/viewport";
import {
  shouldShowCustomerFooter,
  shouldShowDeliveryFooter,
} from "../../helpers/persistentBottomNav";

const PersistentAppNav = ({ location }) => {
  if (isDesktopViewport()) {
    return null;
  }

  const path = (location && location.pathname) || "";

  if (shouldShowDeliveryFooter(path)) {
    return <DeliveryBottomNav persistentChrome />;
  }

  if (shouldShowCustomerFooter(path)) {
    return <Footer persistentChrome />;
  }

  return null;
};

export default withRouter(PersistentAppNav);
